import styled from 'styled-components';

import { MEDIA_QUERIES } from "@constants";

export const ClassesPageClassesDIV = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
  margin-bottom: var(--spacing--XL);

  &.classes-count--1 {
    grid-template-columns: minmax(440px, 1323px);
    justify-content: center;
  }
  
  ${MEDIA_QUERIES.L} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${MEDIA_QUERIES.XL} {
    grid-template-columns: repeat(3, 1fr);

    &.classes-count--2,
    &.classes-count--4 {
      grid-template-columns: repeat(2, 1fr);
    }

    &.classes-count--5 {
      grid-template-columns: repeat(6, calc(100% / 6 - 24px * 5 / 6));
    }
  }
`;

export const ClassesPageRecordedContentDIV = styled.div`
  text-align: center;
  margin-bottom: calc(var(--spacing--L) - 10px);
  

  p {
    color: var(--color--charcoal-700);
  }

  ${MEDIA_QUERIES.M} {
    margin-bottom: var(--spacing--L);
  }
`;

export const ClassesPageRecordedClassesDIV = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--spacing--S);
  margin-bottom: 80px;
  
  ${MEDIA_QUERIES.M} {
    grid-template-columns: repeat(2, 1fr);
    gap: var(--spacing--M);
  }
  
  ${MEDIA_QUERIES.L} {
    grid-template-columns: repeat(3, 1fr);
    gap: var(--spacing--M);
  }
`;
